// src/pages/LoginPage.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FiEye, FiEyeOff, FiLogIn } from "react-icons/fi";
import { IoHomeOutline } from "react-icons/io5";
import uzFlag from "../assets/uzb.png";
import { setAuthData } from "../utils/auth";
import { useLoginMutation } from "../context/authApi"; // 🔥 YANGI QATOR
// agar login API qilgan bo'lsang: import { useLoginMutation } from "../context/authApi";

export default function LoginPage() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");


  const navigate = useNavigate();
  const [login, { isLoading }] = useLoginMutation();
  // const [login, { isLoading }] = useLoginMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!phone.trim() || !password.trim()) {
      setError("Telefon raqami va parolni kiriting.");
      return;
    }

    try {
      const res = await login({
        phone: "+998" + phone,
        password,
      }).unwrap(); // { token, user }

      setAuthData({
        token: res.token,
        user: res.user,
      });

      navigate("/dashboard");
    } catch (err) {
      console.error("login error", err);
      setError(err?.data?.message || "Server xatosi");
    }
  };


  return (
    <div className="min-h-screen flex flex-col pt-12 pb-8 sm:pt-16 sm:pb-12 md:pt-20 md:pb-16 lg:pt-24 lg:pb-20 xl:pt-28 xl:pb-24 bg-gradient-to-b from-[#f6f9ff] via-white to-[#fff8ff]">
      {/* Logo */}
      <div className="pt-8 flex justify-center">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-full bg-black flex items-center justify-center text-white font-semibold text-lg">
            L
          </div>
          <span className="text-lg font-semibold text-gray-900">
            LiveQuiz.uz
          </span>
        </div>
      </div>

      {/* Card */}
      <div className="flex-1 flex items-start justify-center mt-4 px-4 pb-10">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-lg border border-gray-100 px-8 py-8 sm:px-10 sm:py-10">
          {/* Bosh sahifa */}
          <div className="flex justify-end mb-4 text-xs text-gray-500">
            <Link
              to="/"
              className="flex items-center gap-1 hover:text-gray-800"
            >
              <IoHomeOutline className="text-base" />
              Bosh sahifa
            </Link>
          </div>

          {/* Title */}
          <div className="text-center mb-6">
            <h1 className="text-center text-2xl font-bold text-gray-900">
              Kirish
            </h1>
            <p className="text-center text-gray-500 mt-2 text-sm">
              Hisobingizga kiring
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Telefon raqami */}
            <div>
              <label className="text-sm font-medium text-gray-700">
                Telefon raqami <span className="text-red-500">*</span>
              </label>

              <div className="flex">
                <span className="inline-flex items-center gap-1 px-3 border border-r-0 border-gray-200 bg-gray-50 rounded-l-xl text-sm text-gray-700">
                  <img
                    src={uzFlag}
                    alt="UZ"
                    className="h-4 w-6 rounded-sm object-cover"
                  />
                  +998
                </span>
                <input
                  type="tel"
                  placeholder="XX XXX XX XX"
                  className="flex-1 rounded-r-xl border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:bg-white focus:border-black focus:ring-1 focus:ring-black outline-none"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            </div>

            {/* Parol */}
            <div>
              <label className="text-sm font-medium text-gray-700">
                Parol
              </label>
              <div className="flex items-center rounded-xl border border-gray-200 bg-gray-50 px-3 py-2">
                <input
                  type={showPass ? "text" : "password"}
                  placeholder="Parolni kiriting"
                  className="flex-1 bg-transparent text-sm border-none outline-none"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  onClick={() => setShowPass((s) => !s)}
                  className="text-gray-500"
                >
                  {showPass ? (
                    <FiEyeOff className="w-4 h-4" />
                  ) : (
                    <FiEye className="w-4 h-4" />
                  )}
                </button>
              </div>
            </div>

            {/* Xato xabar */}
            {error && (
              <p className="text-[11px] text-red-500 leading-snug">{error}</p>
            )}

            {/* Kirish tugmasi */}
            <div className="pt-1">
              <button
                type="submit"
                disabled={isLoading}
                className="w-full bg-black text-white py-3 rounded-lg mt-0 flex items-center justify-center gap-2 hover:bg-gray-900 transition disabled:opacity-60 disabled:cursor-not-allowed"
              >
                <FiLogIn className="w-4 h-4" />
                {isLoading ? "Kirilmoqda..." : "Kirish"}
              </button>
            </div>

          </form>

          {/* Parolni unutdingizmi */}
          <div className="mt-4 text-center">
            <button
              type="button"
              className="text-xs text-gray-600 hover:text-gray-900"
            >
              Parolni unutdingizmi?
            </button>
          </div>

          <div className="border-t border-gray-200 mt-4 mb-4" />

          {/* Ro‘yxatdan o‘tish */}
          <div className="text-center space-y-2">
            <p className="text-xs text-gray-500">Hisobingiz yo‘qmi?</p>
            <Link
              to="/register-phone"
              className="w-full bg-white text-black py-3 border border-gray-200 rounded-lg mt-2 flex items-center justify-center gap-2 hover:bg-gray-200 transition"
            >
              Ro‘yxatdan o‘tish
            </Link>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="pb-9 text-center text-[11px] text-gray-400">
        © {new Date().getFullYear()} LiveQuiz.uz. Barcha huquqlar
        himoyalangan.
      </div>
    </div>
  );
}
